const PoliticasEFormularios = () => {
    const components = document.querySelectorAll('[data-component="politicas_e_formularios"]');

    components.forEach(component => {
        const select = component.querySelector('#categoria');
        const items = component.querySelectorAll('[data-filtro]');

        function applyFilter(filter) {
            items.forEach(item => {
                const categorias = item.dataset.filtro ? item.dataset.filtro.split(' ') : [];
                if (filter === '' || categorias.includes(filter)) {
                    item.style.display = '';
                } else {
                    item.style.display = 'none';
                }
            });
        }

        if (select) {
            select.addEventListener('change', e => {
                applyFilter(e.target.value);
            });
        }
    });
};

export default PoliticasEFormularios;

if (document.querySelectorAll('[data-component="politicas_e_formularios"]').length) {
    PoliticasEFormularios();
}
